export default [{
  path: '/caixa-postal-dte',
  component: {
    name: 'caixapostaldteBase',
    template: '<router-view />',
    meta: {
      resource: 'caixapostal_dte',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'caixapostal_dte-view',
    component: () => import('@/app/caixa-postal-dte/DTEView.vue'),
    meta: {
      resource: 'caixapostal_dte',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'caixapostal_dte-view',
      pageTitle: 'Caixa postal DTE',
      breadcrumb: [
        {
          text: 'Caixa postal DTE',
          to: { name: 'caixapostal_dte-view' },
          active: true,
        },
      ],
    },
  }],
},
]
